/**
 * Entry point for development and production PWA builds.
 */
import 'regenerator-runtime/runtime';
import { createRoot } from 'react-dom/client';
import React from 'react';
import { routerBasename } from './utils/publicUrl';
import { adalahHalamanPasien } from './utils/halamanPasien';

/**
 * EXTENSIONS AND MODES
 * =================
 * pluginImports.js is dynamically generated from extension and mode
 * configuration at build time.
 *
 * pluginImports.js imports all of the modes and extensions and adds them
 * to the window for processing.
 */
export { history } from './utils/history';
export { preserveQueryParameters, preserveQueryStrings } from './utils/preserveQueryParameters';
export {
  isIdentityHidden,
  setIdentityHidden,
  toggleIdentityHidden,
  useIdentityHidden,
  applyIdentityPrivacyClass,
  clearIdentityPrivacyClass,
} from './utils/identityPrivacy';
export { default as API_CONFIG } from './config/apiConfig';
// Token autentikasi. Diekspor supaya extension tidak perlu tahu nama key-nya
// di localStorage; sebelumnya tiap pemanggil menuliskannya sendiri, dengan
// rantai cadangan ke key yang tidak pernah ditulis siapa pun.
export { getToken as getAuthToken } from './services/authService';
import { installSessionGuard } from './services/sessionGuard';

// Token ditolak API (kedaluwarsa/dicabut) -> keluar ke halaman login, bukan galat di tiap layar.
installSessionGuard();

/**
 * Halaman hasil untuk pasien (/patient/:token) dibuka di ponsel lewat tautan WhatsApp, dan
 * pasien selalu pengunjung pertama (tanpa cache). Memuat seluruh aplikasi viewer (sekitar
 * 2,5 MB gzip, 10 MB mentah) hanya untuk satu halaman teks membuatnya lambat, jadi rute ini
 * memuat entri ringan sendiri. Aplikasi lengkap (App, extension, mode) di bawah dimuat dengan
 * import() sehingga tidak ikut terunduh untuk pasien.
 */
const mulaiHalamanPasien = () =>
  import(/* webpackChunkName: "patient" */ './patientEntry').then(modul =>
    modul.default(document.getElementById('root'))
  );

const mulaiAplikasiLengkap = async () => {
  const [
    { default: App },
    { modes: defaultModes, extensions: defaultExtensions },
    { default: loadDynamicConfig },
  ] = await Promise.all([
    import('./App'),
    import('./pluginImports'),
    import('./loadDynamicConfig'),
  ]);

  const config_json = await loadDynamicConfig(window.config);
  // Reset Dynamic config if defined
  if (config_json !== null) {
    window.config = config_json;
  }

  /**
   * Combine our appConfiguration with installed extensions and modes.
   * In the future appConfiguration may contain modes added at runtime.
   *  */
  const appProps = {
    config: window ? window.config : {},
    defaultExtensions,
    defaultModes,
  };

  const container = document.getElementById('root');

  const root = createRoot(container);
  root.render(React.createElement(App, appProps));
};

(adalahHalamanPasien(window.location.pathname, routerBasename)
  ? mulaiHalamanPasien()
  : mulaiAplikasiLengkap()
).catch(error => {
  console.error('Gagal memulai aplikasi', error);
});
